import { currencyFormatter } from '../../QuotePage/content/QuoteGrids/utils';
import moment from 'moment';

const percentageFormatter = (params) => {
  if (params.value == null) return '';
  return `${(params.value * 100).toFixed(2)}%`;
};

const numberFormatter = (params) => {
  if (params.value == null) return '';
  return params.value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const dateFormatter = (params) => {
  if (params.value == null || params.value === '') return '';

  // If already a formatted string, return as-is
  if (typeof params.value === 'string' && /[a-zA-Z]/.test(params.value)) {
    return params.value;
  }

  // Try to parse and format
  const parsed = moment(params.value);
  return parsed.isValid() ? parsed.format('MM-DD-YYYY') : params.value;
};

export const getAggregationColumnDefs = (selectedRadio) => {
  return [
    {
      headerName: selectedRadio.toUpperCase(),
      field: selectedRadio,
      rowGroup: true,
      enableRowGroup: true,
    },
    {
      headerName: 'Max - coverage_5_mi',
      field: 'coverage5mi',
      aggFunc: 'max',
      valueGetter: (params) => params.data?.coverage5mi,
      valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
    },
    {
      headerName: 'Max - coverage_10_mi',
      field: 'coverage10mi',
      aggFunc: 'max',
      valueGetter: (params) => params.data?.coverage10mi,
      valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
    },
    {
      headerName: 'Max - coverage_25_mi',
      field: 'coverage25mi',
      aggFunc: 'max',
      valueGetter: (params) => params.data?.coverage25mi,
      valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
    },
  ];
};

export const getPIFColumnDefs = () => [
  {
    headerName: 'coverage_at',
    field: 'coverage_at',
    pinned: 'left',
    width: 120,
    valueFormatter: dateFormatter,
  },
  {
    headerName: 'customer_name',
    field: 'customer_name',
    pinned: 'left',
    width: 180,
  },
  {
    headerName: 'policy_number',
    field: 'policy_number',
    pinned: 'left',
    width: 160,
  },
  {
    headerName: 'name',
    field: 'name',
    width: 150,
  },
  {
    headerName: 'address',
    field: 'address',
    width: 250,
  },
  {
    headerName: 'visible_address',
    field: 'visible_address',
    width: 250,
  },
  {
    headerName: 'only_address',
    field: 'only_address',
    width: 250,
  },
  {
    headerName: 'postcode',
    field: 'postcode',
    width: 100,
  },
  {
    headerName: 'region_code',
    field: 'region_code',
    width: 100,
  },
  {
    headerName: 'country_code',
    field: 'country_code',
    width: 100,
  },
  {
    headerName: 'lat',
    field: 'lat',
    width: 120,
    valueFormatter: numberFormatter,
  },
  {
    headerName: 'lon',
    field: 'lon',
    width: 120,
    valueFormatter: numberFormatter,
  },
  {
    headerName: 'risk_id',
    field: 'risk_id',
    width: 120,
  },
  {
    headerName: 'fema_flood_zone',
    field: 'fema_flood_zone',
    width: 160,
  },
  {
    headerName: 'katrisk_flood_score',
    field: 'katrisk_flood_score',
    width: 180,
  },
  {
    headerName: 'crime_index',
    field: 'crime_index',
    width: 180,
  },
  {
    headerName: 'wildfire',
    field: 'wildfire',
    width: 100,
  },
  {
    headerName: 'all_mce_loc_net_premium',
    field: 'all_mce_loc_net_premium',
    width: 220,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'policy_loc_net_premium',
    field: 'policy_loc_net_premium',
    width: 180,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'covered_value',
    field: 'covered_value',
    width: 150,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'excess_5m',
    field: 'excess_5m',
    width: 130,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'policy_or_quote_gwp',
    field: 'policy_or_quote_gwp',
    width: 150,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'bound_rate',
    field: 'bound_rate',
    width: 120,
    valueFormatter: percentageFormatter,
  },
  {
    headerName: 'windhail_deductible',
    field: 'windhail_deductible',
    width: 160,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'flood_deductible',
    field: 'flood_deductible',
    width: 150,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'flood_payout_limit',
    field: 'flood_payout_limit',
    width: 160,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'comp_deductible',
    field: 'comp_deductible',
    width: 150,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'coll_deductible',
    field: 'coll_deductible',
    width: 140,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'terror_deductible',
    field: 'terror_deductible',
    width: 150,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'false_pretense_deductible',
    field: 'false_pretense_deductible',
    width: 190,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'earthquake_deductible',
    field: 'earthquake_deductible',
    width: 180,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'earthquake_payout_limit',
    field: 'earthquake_payout_limit',
    width: 190,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'occurrence_deductible',
    field: 'occurrence_deductible',
    width: 180,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'csr_id',
    field: 'csr_id',
    width: 100,
  },
  {
    headerName: 'risk_zone_id',
    field: 'risk_zone_id',
    width: 120,
  },
  {
    headerName: 'county',
    field: 'county',
    width: 120,
  },
  {
    headerName: 'crz_id',
    field: 'crz_id',
    width: 100,
    cellDataType: 'text',
  },
  {
    headerName: 'coverage_5_mi',
    field: 'coverage_5_mi',
    width: 140,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'coverage_10_mi',
    field: 'coverage_10_mi',
    width: 140,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'coverage_25_mi',
    field: 'coverage_25_mi',
    width: 140,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'coverage_50_mi',
    field: 'coverage_50_mi',
    width: 140,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
  {
    headerName: 'coverage_100_mi',
    field: 'coverage_100_mi',
    width: 150,
    valueFormatter: (field) => currencyFormatter({ field, withDecimals: true }),
  },
];

// Helper function to get per occurrence deductible from policy attributes
const getPerOccurrenceDeductible = (loc) => {
  return loc.attributes?.perOccurrenceDeductible ?? null;
};

export const mapLocationToPIFRow = (loc) => ({
  coverage_at: loc.coverageAt || '',
  customer_name: loc.customerName || '',
  policy_number: loc.attributes?.policyNumber || '',
  name: loc.name || '',
  address: loc.address || '',
  visible_address: loc.attributes?.visibleAddress || '',
  only_address: loc.attributes?.onlyAddress || loc.address || '',
  postcode: loc.postcode || '',
  region_code: loc.regionCode || '',
  country_code: loc.countryCode || '',
  lat: loc.lat ?? null,
  lon: loc.lon ?? null,
  risk_id: loc.riskId || '',
  fema_flood_zone: loc.attributes?.femaFloodZone || '',
  katrisk_flood_score: loc.attributes?.katriskFloodScore || '',
  crime_index: loc.attributes?.crimeIndex || '',
  wildfire: loc.attributes?.wildfire || '',
  all_mce_loc_net_premium: loc.aggregates?.allMceLocNetPremium ?? null,
  policy_loc_net_premium: loc.aggregates?.policyLocNetPremium ?? null,
  covered_value: loc.coveredValue ?? null,
  excess_5m: loc.aggregates?.excess5m ?? null,
  policy_or_quote_gwp: loc.aggregates?.policyOrQuoteGwp ?? null,
  bound_rate: loc.aggregates?.boundRate ?? null,
  windhail_deductible: loc.aggregates?.windHailDeductible ?? null,
  flood_deductible: loc.aggregates?.floodDeductible ?? null,
  flood_payout_limit: loc.aggregates?.floodPayoutLimit ?? null,
  comp_deductible: loc.aggregates?.compDeductible ?? null,
  coll_deductible: loc.aggregates?.collDeductible ?? null,
  terror_deductible: loc.aggregates?.terrorDeductible ?? null,
  false_pretense_deductible: loc.aggregates?.falsePretenseDeductible ?? null,
  earthquake_deductible: loc.aggregates?.earthquakeDeductible ?? null,
  earthquake_payout_limit: loc.aggregates?.earthquakePayoutLimit ?? null,
  occurrence_deductible: getPerOccurrenceDeductible(loc),
  csr_id: loc.attributes?.csrId || '',
  risk_zone_id: loc.attributes?.riskZoneId || '',
  county: loc.county || loc.attributes?.county || '',
  crz_id: loc.attributes?.crzId || '0',
  coverage_5_mi: loc.aggregates?.coverage5mi ?? null,
  coverage_10_mi: loc.aggregates?.coverage10mi ?? null,
  coverage_25_mi: loc.aggregates?.coverage25mi ?? null,
  coverage_50_mi: loc.aggregates?.coverage50mi ?? null,
  coverage_100_mi: loc.aggregates?.coverage100mi ?? null,
});
